<script lang="ts">
	interface Props {
		src: string
		onStop?: () => void
		onPlay?: () => void
		onPause?: () => void
		isOpen: boolean
		errorMessage?: string
		videoElement?: HTMLVideoElement
	}

	let {
		src,
		isOpen,
		onStop,
		onPlay,
		onPause,
		errorMessage = "Preview not available. Please re-render your scene.",
		videoElement = $bindable(),
	}: Props = $props()

	let videoElem: HTMLVideoElement = $state()

	let hasError = $state(false)
	let isLoading = $state(true)

	// Sync internal videoElem with bindable videoElement prop
	$effect(() => {
		videoElement = videoElem
	})

	function resetPlayback() {
		if (!videoElem) return
		videoElem.pause()
		setTimeout(() => {
			videoElem.currentTime = 0
		}, 500)
	}

	function handleError(e) {
		console.error("Unable to load preview", e)
		hasError = true
	}

	function handleLoad(e) {
		isLoading = false
	}

	$effect(() => {
		if (videoElem && src) {
			videoElem.load()
			hasError = false
		}
	})

	$effect(() => {
		if (!isOpen) resetPlayback()
		else if (isOpen && videoElem) videoElem.play()
	})

	$effect(() => {
		if (src) {
			isLoading = true
			hasError = false
		}
	})
</script>

{#if hasError}
	<div class="preview-unavailable">
		<p>{errorMessage}</p>
	</div>
{:else}
	<video
		bind:this={videoElem}
		controls
		width="100%"
		height="100%"
		onerror={handleError}
		onended={onStop}
		onplay={onPlay}
		onpause={onPause}
		autoplay={true}
	>
		<source {src} type="video/mp4" onerror={handleError} onload={handleLoad} />
	</video>
{/if}

<style>
	.preview-unavailable {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		font-size: var(--h1);
	}

	.preview-unavailable p {
		max-width: 80%;
		text-align: center;
	}
</style>
